import { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';

import {setSelectedGeoObjArray} from '../../actions/ui'

import mapStateToProps from "./mapStateToProps";

/**Это очень плохой компонент. Фу таким быть!
 * Он следит чтоб там где он включен не было выбрано несколько флажков гео объектов
 * и если выберется несколько - он оставит только последний в массиве
 * Фу таким быть - потому что все остальные подписчики на список флажков в этот момент 
 * будут рендериться дважды
 */
const CheckBoxController = () => {
    const {selectedGeoObjArray=[]} = useSelector(mapStateToProps)
    const dispatch = useDispatch();
    useEffect(()=>{
        if(selectedGeoObjArray?.length && selectedGeoObjArray?.length>1){
            dispatch(setSelectedGeoObjArray([selectedGeoObjArray[selectedGeoObjArray.length-1]]))
        }
    },[selectedGeoObjArray?.length])
    return null
}

export default CheckBoxController